export default __webpack_public_path__ + "static/media/property_1_8.5f53b31a.webp";